module.exports = __webpack_public_path__ + "img/background-desktop-system-details.91ee7f7b.png";